const translations = {
    pt: {
        name: 'E-mail ou nome de usuário',
        namePlaceholder: 'seu.email@exemplo.com',
        password: 'Senha',
        passwordPlaceholder: 'Digite sua senha',
        button: 'Entrar',
        errorInvalid: 'Credenciais inválidas. Por favor, tente novamente.',
        errorServer: 'Erro interno do servidor. Por favor, tente novamente mais tarde.',
        welcome: 'Bem-vindo(a), ',
    },
    en: {
        name: 'Email or username',
        namePlaceholder: 'your.email@example.com',
        password: 'Password',
        passwordPlaceholder: 'Enter your password',
        button: 'Login',
        errorInvalid: 'Invalid credentials. Please try again.',
        errorServer: 'Internal server error. Please try again later.',
        welcome: 'Welcome, ',
    },
};


export default translations;